import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ApiResponse } from "../../../classes/api-response";
import { Constants } from "../../../utils/constants";
import { Box } from "../../../model/box";
import { BoxesService } from "../../../services/boxes-service";
import { SnackService } from "../../../services/snack.service";
import { BoxCertificate } from "../../../model/box-certificate";
import { BoxCertificatesService } from "../../../services/box-certificates.service";
import { merge } from "lodash-es";

@Component({
  selector: 'aw-box-certificate-form',
  templateUrl: './box-certificate-form.component.html',
  styleUrls: ['./box-certificate-form.component.scss']
})
export class BoxCertificateFormComponent implements OnInit {

  boxCertificateForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingBoxes = false;
  saving = false;
  generalError?: ApiResponse;
  _certificate = new BoxCertificate();
  selectedBox?: Box;
  isEditing = false;

  entities = Constants.entities;
  certificateStatus = Constants.certificateStatuses;

  boxes: Box[] = [];

  constructor(
    private certificateService: BoxCertificatesService,
    private boxService: BoxesService,
    private snackService: SnackService,
  ) {

    this.loadingBoxes = true;




    this.boxCertificateForm = new UntypedFormGroup(
      {

        creationDate: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        endDate: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        box: new UntypedFormControl(
          null,
          [
          ]
        ),
        cmId: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      }
    );
  }

  @Input() set certificate(value: BoxCertificate) {
    this._certificate = merge(new BoxCertificate(), value);
    // this.selectedBox = value.box;
    this.isEditing = !!this._certificate.id;
    this.boxCertificateForm.patchValue(this._certificate);
  }

  ngOnInit(): void {
    if (!this.isEditing) {
      this.boxService.getAllBoxes().subscribe(boxes => {
        boxes.forEach(box => {
          box.currentCertificate = box?.boxCertificates?.find(certificate => certificate?.status !== this.certificateStatus.expired && certificate?.status !== this.certificateStatus.revoked);
          if (!box.currentCertificate)
            this.boxes.push(box);
        });
        this.loadingBoxes = false;
      });
    }
  }

  saveBoxCertificate(): void {

    this.saving = true;

    const newCertificate = merge(new BoxCertificate(), this._certificate, this.boxCertificateForm.value);

    this.generalError = undefined;

    if (this._certificate.id) {
      this.certificateService.updateBoxCertificate(newCertificate)
        .subscribe(
          () => {
            this.saving = false;
            this.certificate = newCertificate;
            this.snackService.success('Certificate updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {

      this.certificateService.createBoxCertificate(newCertificate)
        .subscribe(
          () => {
            this.saving = false;
            this.certificate = newCertificate;
            this.snackService.success('Certificte created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

}
